<script>
export default {
  name: "ConfigClassTree",
  props: {
    confirmLoading: Boolean,
    title: {
      type: String,
      default: "配置班级",
    },
    info: Object,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      spinning: false,
      step: 1,
      treeData: [],
      checkedKeys: [],
      treeKey: Date.now(),
    }
  },
  watch: {
    visible(bool) {
      if (bool) {
        this.getClassData();
      }
    }
  },
  methods: {
    //获取列表
    getClassData() {
      this.spinning = true
      this.$http.ReportService.GroupTrainingReportClassTree(this.$store.getters['organization/getReportInfo'].id).then((res) => {
        this.treeData = [{
          title: "全部",
          key: "_0",
          classes: deep(res.data)
        }];
        this.treeKey = Date.now();
      }).finally(() => {
        this.spinning = false;
      });

      function deep(arr) {
        return arr.map(m => {
          m.title = m.gradeName || m.className
          m.key = m.gradeId ? "_" + m.gradeId : m.classId
          if (Array.isArray(m.classes)) {
            m.classes = deep(m.classes);
          }
          return m;
        })
      }
    },
    modalOk() {
      this.$emit("ok", this.checkedKeys.filter(f => typeof f !== 'string'));
      this.modalCancel();
    },
    modalCancel() {
      this.checkedKeys = [];
      this.$emit("visible", false);
    },
  },
};
</script>

<template>
  <a-modal :visible="visible" :confirm-loading="confirmLoading" @cancel="modalCancel" @ok="modalOk" :title="title" width="75%">
    <a-spin :spinning="spinning" style="min-height: 300px">
      <a-form-model  :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
        <template v-if="step == 1">
          <a-form-model-item label="班级选择" prop="checkedKeys" required>
            <a-tree :key="treeKey"
              checkable
              :replaceFields="{ children: 'classes' }"
              :defaultExpandAll="true"
              :tree-data="treeData"
              v-model="checkedKeys" />
          </a-form-model-item>
        </template>
        <template v-if="step == 2">
          <a-form-model-item label="班级选择" prop="checkedKeys">
            <a-tree :replaceFields="{ children: 'childs', key: 'gradeClassID' }" :key="student.treeKey" :defaultExpandAll="true" :tree-data="student.treeData1" />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<style scoped lang="less">

</style>
